import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const signInCacheKey = 'signIn';
export const signInDocument = /* GraphQL */ `
    mutation SignIn($formFields: SignInFormFields!) {
        signIn(formFields: $formFields) {
            userId
            success
            message
            messages
            maxLoginAttempts
            mvpdDispute {
                isDmaInDispute
                mvpdProvider
            }
        }
    }
`;
export const signInMutation = graphql(signInDocument);
